import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseButton } from './PurchaseButton';
import { ShieldCheck, Zap, Lock, Sparkles } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-32 px-4 overflow-hidden bg-cream" data-id="element-189">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-190">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-soft/30 blur-3xl" data-id="element-191"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-accent/15 blur-3xl" data-id="element-192"></div>
        <div className="absolute bottom-0 right-0 w-[30%] h-[30%] rounded-full bg-gold/10 blur-3xl" data-id="element-193"></div>
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 lg:gap-16 items-center relative z-10" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6 md:space-y-7" data-id="element-195">
          <div className="inline-flex items-center gap-2 self-start bg-white px-4 py-2 rounded-full border border-soft/50 shadow-sm" data-id="element-196">
            <Sparkles size={14} className="text-gold" data-id="element-197" />
            <span className="font-sans text-xs font-bold text-primary tracking-wide uppercase" data-id="element-198">
              Para mujeres que están listas para soltar
            </span>
          </div>

          <h1 className="font-serif font-bold text-4xl sm:text-5xl md:text-6xl text-primary leading-[1.1] tracking-tight" data-id="element-199">
            Suelta a tu ex,{' '}
            <span className="italic text-accent" data-id="element-200">vuelve a ti</span> y cierra el
            ciclo en 21 días, aunque tu corazón aún lo esté esperando.
          </h1>

          <p className="font-sans text-base md:text-lg text-ink/80 leading-relaxed" data-id="element-201">
            Un proceso guiado para dejar de revisar su teléfono, soltar el apego
            y <span className="font-bold text-primary" data-id="element-202">recuperar tu poder</span>{' '}
            paso a paso, sin depender de una explicación, una disculpa o un
            regreso que <em data-id="element-203">quizás nunca llegue</em>.
          </p>

          <div className="flex flex-col items-center md:items-start gap-4 pt-2" data-id="element-204">
            <PurchaseButton text="SÍ, QUIERO CERRAR ESTE CICLO" hideMicrocopy data-id="element-205" />

            <div className="flex flex-wrap gap-2 justify-center md:justify-start max-w-md" data-id="element-206">
              <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded-full border border-soft/40 text-xs font-bold text-primary shadow-sm" data-id="element-207">
                <Zap size={14} className="text-gold" data-id="element-208" /> Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded-full border border-soft/40 text-xs font-bold text-primary shadow-sm" data-id="element-209">
                <ShieldCheck size={14} className="text-relief" data-id="element-210" /> Garantía 7
                días
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-2 rounded-full border border-soft/40 text-xs font-bold text-primary shadow-sm" data-id="element-211">
                <Lock size={14} className="text-accent" data-id="element-212" /> Pago seguro
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center items-center py-10" data-id="element-213">
          <motion.div animate={{
          y: [0, -10, 0],
          rotate: [0, 5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity
        }} className="absolute top-0 right-4 w-16 h-16 bg-soft/40 rounded-[50%_30%_50%_30%] blur-sm" data-id="element-214"></motion.div>
          <motion.div animate={{
          y: [0, 10, 0],
          rotate: [0, -5, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity
        }} className="absolute bottom-4 left-0 w-12 h-12 bg-accent/30 rounded-[30%_50%_30%_50%] blur-sm" data-id="element-215"></motion.div>

          <div className="relative w-full max-w-md mx-auto" data-id="element-216">
            <div className="absolute inset-0 bg-gradient-to-br from-soft/40 to-accent/20 rounded-3xl blur-2xl scale-95" data-id="element-217"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rZ537b5jHgTsagL6gNCPjC/Ad3.png" alt="EL CÓDIGO DEL CIERRE™ — Sistema de 21 días con guía principal, plan de acción, kit de frases y bonos exclusivos" className="relative w-full h-auto rounded-2xl shadow-2xl border border-soft/30" data-id="element-218" />
          </div>
        </motion.div>
      </div>
    </section>;
}